import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import LegalLayout from './LegalLayout';

const FAQS = [
  { q: 'How do I make a booking on Elite Travo?', a: 'Pick a product tab (Hotels, Flights, Buses…), fill in your dates and travellers, hit Search, and choose from the live, ranked results. Click "View Details", review the breakdown, then complete payment via Razorpay. You will receive a voucher/PNR immediately.' },
  { q: 'Are the prices shown on Elite Travo final?', a: 'Yes. Every price you see includes base fare, supplier taxes, our service fee and any applicable GST. There are no hidden charges at the payment step.' },
  { q: 'How do I cancel a booking?', a: 'Sign in, go to My Bookings, open the relevant booking and tap Cancel. The supplier\'s cancellation policy is shown upfront along with the net refundable amount.' },
  { q: 'When will I receive my refund?', a: 'Refunds are initiated automatically when you cancel. Credit/debit cards take 7-10 working days, UPI and net-banking take 5-7 working days. Wallet credits are instant.' },
  { q: 'My payment was deducted but the booking failed. What now?', a: 'In this case the booking is automatically marked pending and the payment is reversed by the bank within 7 working days. If the amount is not credited back, write to support@elitetravo.com with the order id and bank statement.' },
  { q: 'Can I book for someone else?', a: 'Absolutely. Just enter the actual traveller(s)\' details during checkout — their name(s) will appear on the ticket / voucher.' },
  { q: 'Do you offer corporate (business) accounts?', a: 'Yes. Switch the Personal/Business toggle on the homepage and sign up with a work email to access corporate features like GST-compliant invoices and business deals.' },
  { q: 'Is my payment information secure?', a: 'We do not store card numbers or CVVs on our servers. All payments are processed through PCI-DSS compliant payment partners (Razorpay and equivalents) with TLS 1.2+ in transit.' },
  { q: 'I have a question that isn\'t covered here.', a: 'Drop us a line at support@elitetravo.com or use the form on our Contact page. We typically reply within 24 hours.' },
];

const FaqItem = ({ q, a, idx }) => {
  const [open, setOpen] = useState(idx === 0);
  return (
    <div className="border-b border-gray-200 dark:border-gray-800 py-4">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        data-testid={`faq-question-${idx}`}
        className="w-full flex items-center justify-between text-left gap-3"
      >
        <span className="font-semibold text-gray-900 dark:text-white text-[15px]">{q}</span>
        <ChevronDown className={`h-4 w-4 text-gray-500 flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <p className="text-[14px] text-gray-600 dark:text-gray-400 mt-2 leading-relaxed" data-testid={`faq-answer-${idx}`}>{a}</p>}
    </div>
  );
};

const Faq = () => (
  <LegalLayout title="Frequently Asked Questions" eyebrow="Help Centre" lastUpdated="29 May 2026">
    <div className="not-prose">
      {FAQS.map((f, i) => <FaqItem key={i} idx={i} q={f.q} a={f.a} />)}
    </div>
  </LegalLayout>
);

export default Faq;
